import React from 'react'
import { Title } from '@components/admin/title'

interface Props {
  title: string
  subTitle?: string
}

export const PageTitle: React.FC<Props> = ({ title, subTitle }) => {
  return (
    <>
      <Title level="h1">{title}</Title>
      {subTitle && <span>{subTitle}</span>}
      <hr className="h-1 bg-gray-800 mt-2 mb-6" />
    </>
  )
}
